import React from 'react';
import { Card, Col, Row, Container, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import {
  FaFileContract,
  FaUserEdit,
  FaMapMarkedAlt,
  FaExclamationCircle,
  FaBan,
  FaBoxOpen,
  FaShieldAlt,
  FaCheckCircle,
  FaMailBulk,
  FaClock,
  FaShippingFast,
  FaSearch,
  FaMoneyBillWave,
  FaTruck,
  FaUserFriends,
  FaHeadset,
  FaWarehouse,
  FaUserMinus,
  FaHandPaper,
  FaEdit,
  FaHome,
  FaWhatsapp,
  FaEnvelope,
  FaBuilding,
  FaInstagram
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from '../assets/mboxLogo.jpeg';

const TerminosYCondiciones = () => {
  const termsSections = [
    {
      icon: <FaFileContract className="text-primary me-2 fs-5" />,
      title: "Aceptación de los Términos",
      content: (
        <ul className="mb-0 ps-3">
          <li>La apertura y uso del casillero implica la aceptación total de estas políticas.</li>
          <li>Los presentes términos constituyen un acuerdo entre MBOX S. de R.L. y el cliente.</li>
        </ul>
      )
    },
    {
      icon: <FaUserEdit className="text-success me-2 fs-5" />,
      title: "Creación y Uso del Casillero",
      content: (
        <ul className="mb-0 ps-3">
          <li>La creación y mantenimiento del casillero es completamente gratuita.</li>
          <li>El cliente deberá proporcionar información veraz y actualizada.</li>
          <li>El casillero es personal e intransferible.</li>
        </ul>
      )
    },
    {
      icon: <FaMapMarkedAlt className="text-info me-2 fs-5" />,
      title: "Dirección de Casillero",
      content: (
        <ul className="mb-0 ps-3">
          <li>Es responsabilidad del cliente utilizar correctamente la dirección asignada.</li>
          <li>Todo paquete deberá incluir la palabra "MBOX" y el número de casillero correspondiente.</li>
          <li>Los paquetes que lleguen sin identificación correcta podrán ingresar al área de paquetes desconocidos, ocasionando retrasos en su localización.</li>
          <li>MBOX podrá aplicar cargos administrativos por procesos de identificación extraordinarios.</li>
        </ul>
      )
    },
    {
      icon: <FaExclamationCircle className="text-warning me-2 fs-5" />,
      title: "Declaraciones del Cliente",
      content: (
        <ul className="mb-0 ps-3">
          <li>Declara que no enviará ni intentará enviar drogas, dinero en efectivo, armas de fuego, municiones, explosivos o artículos prohibidos por la ley.</li>
          <li>Declara que los productos enviados cumplen con las leyes de exportación e importación aplicables.</li>
          <li>Declara que toda la información proporcionada es correcta y actualizada.</li>
          <li>Acepta cumplir las políticas y procedimientos establecidos por MBOX.</li>
        </ul>
      )
    },
    {
      icon: <FaBan className="text-danger me-2 fs-5" />,
      title: "Productos Prohibidos",
      content: (
        <ul className="mb-0 ps-3">
          <li>Armas de fuego y sus accesorios.</li>
          <li>Explosivos o materiales inflamables.</li>
          <li>Drogas o sustancias ilegales.</li>
          <li>Dinero en efectivo.</li>
          <li>Material pornográfico prohibido por ley.</li>
          <li>Animales vivos.</li>
          <li>Productos perecederos.</li>
          <li>Medicamentos controlados o restringidos.</li>
          <li>Cualquier artículo prohibido por las leyes de Estados Unidos, Honduras o regulaciones internacionales.</li>
        </ul>
      )
    },
    {
      icon: <FaBoxOpen className="text-primary me-2 fs-5" />,
      title: "Reempaque de Compras",
      content: (
        <ul className="mb-0 ps-3">
          <li>MBOX ofrece servicio de reempaque gratuito.</li>
          <li>Los paquetes no son abiertos para verificar contenido.</li>
          <li>El reempaque consiste en consolidar varios paquetes para optimizar espacio y costos de transporte.</li>
        </ul>
      )
    },
    {
      icon: <FaShieldAlt className="text-secondary me-2 fs-5" />,
      title: "Responsabilidad sobre Productos",
      content: (
        <ul className="mb-0 ps-3">
          <li>MBOX es una empresa de logística y transporte.</li>
          <li>No es responsable por errores cometidos por proveedores, tiendas o vendedores.</li>
          <li>No se garantiza la calidad, cantidad, talla, color, funcionamiento o autenticidad de los productos adquiridos.</li>
          <li>Los reclamos relacionados con la compra deberán realizarse directamente con la tienda o proveedor.</li>
        </ul>
      )
    },
    {
      icon: <FaCheckCircle className="text-success me-2 fs-5" />,
      title: "Marcados como Entregados",
      content: (
        <ul className="mb-0 ps-3">
          <li>MBOX no asume responsabilidad por paquetes que aparezcan como "Entregados" en sistemas de rastreo externos y que aún no hayan sido registrados físicamente en nuestra bodega.</li>
          <li>Un paquete será considerado recibido únicamente cuando haya sido procesado y registrado en nuestro sistema interno.</li>
        </ul>
      )
    },
    {
      icon: <FaMailBulk className="text-info me-2 fs-5" />,
      title: "Envíos mediante USPS",
      content: (
        <ul className="mb-0 ps-3">
          <li>USPS no requiere firma obligatoria en muchos de sus servicios.</li>
          <li>Las fechas reflejadas por USPS pueden presentar variaciones.</li>
          <li>MBOX únicamente responderá por paquetes efectivamente recibidos y registrados en nuestras instalaciones.</li>
        </ul>
      )
    },
    {
      icon: <FaClock className="text-warning me-2 fs-5" />,
      title: "Horario de Recepción en Miami",
      content: (
        <ul className="mb-0 ps-3">
          <li>MBOX no se responsabiliza por paquetes entregados fuera del horario de recepción de la bodega.</li>
          <li>Horario de recepción: lunes a viernes de 9:00 a.m. a 5:00 p.m.</li>
        </ul>
      )
    },
    {
      icon: <FaShippingFast className="text-primary me-2 fs-5" />,
      title: "Tiempos de Entrega",
      content: (
        <ul className="mb-0 ps-3">
          <li>Los tiempos de entrega comienzan a contarse desde que el paquete es recibido en nuestra bodega de Florida.</li>
          <li>Los tiempos publicados son estimados y no constituyen una garantía de entrega.</li>
          <li>Los tiempos pueden variar por procesos aduaneros, condiciones climáticas, temporadas altas, días festivos o situaciones ajenas a MBOX.</li>
        </ul>
      )
    },
    {
      icon: <FaSearch className="text-secondary me-2 fs-5" />,
      title: "Inspecciones Aduaneras",
      content: (
        <ul className="mb-0 ps-3">
          <li>Las autoridades aduaneras podrán abrir paquetes para inspección cuando lo consideren necesario.</li>
          <li>MBOX no tiene control sobre estos procedimientos.</li>
          <li>MBOX no será responsable por aperturas realizadas por autoridades competentes.</li>
        </ul>
      )
    },
    {
      icon: <FaMoneyBillWave className="text-success me-2 fs-5" />,
      title: "Tarifas y Cobros",
      content: (
        <ul className="mb-0 ps-3">
          <li>Todas las tarifas pueden ser modificadas sin previo aviso.</li>
          <li>Los ajustes podrán realizarse debido a variaciones del dólar, costos operativos, impuestos o cambios logísticos.</li>
          <li>Las tarifas vigentes serán las publicadas por MBOX al momento de la facturación.</li>
        </ul>
      )
    },
    {
      icon: <FaTruck className="text-info me-2 fs-5" />,
      title: "Envíos Nacionales",
      content: (
        <ul className="mb-0 ps-3">
          <li>Los envíos dentro y fuera de Tegucigalpa tendrán costos adicionales según la ubicación.</li>
          <li>Los servicios de entrega son realizados por empresas externas de mensajería.</li>
          <li>El cliente deberá cancelar los costos correspondientes antes del despacho cuando sea requerido.</li>
        </ul>
      )
    },
    {
      icon: <FaUserFriends className="text-primary me-2 fs-5" />,
      title: "Retiro por Terceras Personas",
      content: (
        <ul className="mb-0 ps-3">
          <li>Cuando una persona distinta al titular retire un paquete, deberá proporcionar la información del casillero para validar la entrega.</li>
          <li>MBOX podrá solicitar información adicional para confirmar la autorización.</li>
        </ul>
      )
    },
    {
      icon: <FaHeadset className="text-warning me-2 fs-5" />,
      title: "Reclamos",
      content: (
        <ul className="mb-0 ps-3">
          <li>Todo reclamo deberá realizarse al momento de recibir el paquete.</li>
          <li>Si el paquete es retirado en oficina, deberá revisarse antes de abandonar las instalaciones.</li>
          <li>Para entregas a domicilio, cualquier incidencia deberá notificarse dentro de las primeras 24 horas posteriores a la recepción.</li>
          <li>Reclamos realizados fuera de este período podrán no ser admitidos.</li>
        </ul>
      )
    },
    {
      icon: <FaWarehouse className="text-secondary me-2 fs-5" />,
      title: "Almacenaje de Paquetes",
      content: (
        <ul className="mb-0 ps-3">
          <li>Los paquetes permanecerán almacenados en Honduras por un máximo de 30 días calendario.</li>
          <li>Una vez vencido este plazo, MBOX podrá disponer del paquete para cubrir costos de transporte, almacenaje, impuestos y gastos administrativos.</li>
        </ul>
      )
    },
    {
      icon: <FaUserMinus className="text-danger me-2 fs-5" />,
      title: "Menores de Edad",
      content: (
        <ul className="mb-0 ps-3">
          <li>Los servicios de MBOX están dirigidos exclusivamente a personas mayores de 18 años.</li>
          <li>No se permite la apertura de casilleros a menores de edad sin la debida autorización y representación legal.</li>
        </ul>
      )
    },
    {
      icon: <FaHandPaper className="text-danger me-2 fs-5" />,
      title: "Conductas Inapropiadas",
      content: (
        <ul className="mb-0 ps-3">
          <li>No se permiten agresiones verbales o físicas contra colaboradores de MBOX.</li>
          <li>No se permite proporcionar información falsa.</li>
          <li>No se permiten intentos de fraude o reclamos falsos.</li>
          <li>No se permite utilizar los servicios para actividades ilícitas.</li>
          <li>MBOX podrá suspender o cancelar cuentas que incumplan estas disposiciones.</li>
        </ul>
      )
    },
    {
      icon: <FaEdit className="text-info me-2 fs-5" />,
      title: "Modificaciones",
      content: (
        <ul className="mb-0 ps-3">
          <li>MBOX S. de R.L. se reserva el derecho de modificar estos términos y condiciones en cualquier momento.</li>
          <li>Las actualizaciones entrarán en vigor una vez publicadas por los canales oficiales de la empresa.</li>
        </ul>
      )
    }
  ];

  const contactInfo = [
    {
      icon: <FaWhatsapp className="me-3 text-success fs-4" />,
      text: "WhatsApp: 9874-4314",
      link: "https://wa.me/50498744314"
    },
    {
      icon: <FaEnvelope className="me-3 text-primary fs-4" />,
      text: "servicioalclientembox@gmail.com",
      link: "mailto:servicioalclientembox@gmail.com"
    },
    {
      icon: <FaBuilding className="me-3 text-info fs-4" />,
      text: "Boulevard Centroamérica, edificio corporativo, tercer nivel Tegucigalpa, Honduras.",
      link: null
    },
    {
      icon: <FaInstagram className="me-3 fs-4" style={{ color: '#E1306C' }} />,
      text: "@mbox.express",
      link: "https://instagram.com/mbox.express"
    }
  ];

  return (
    <section 
      className="py-5" 
      style={{ 
        background: "linear-gradient(135deg, #182848 0%, #4b6cb7 100%)", 
        minHeight: "100vh" 
      }}
    >
      <Container className="px-3" style={{ maxWidth: '1100px' }}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
    
          <Row className="mb-5 align-items-center justify-content-between">
            <Col xs="auto">
              <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
                <Link to="/" className="text-decoration-none">
                  <div className="d-flex align-items-center">
                    <img
                      src={logo}
                      alt="MBox Logo"
                      className="img-fluid me-3 shadow-sm"
                      style={{ height: '45px', borderRadius: '8px' }}
                    />
                    <span className="text-white fw-bold fs-5 d-none d-sm-inline">MBox Honduras</span>
                  </div>
                </Link>
              </motion.div>
            </Col>
            <Col xs="auto">
              <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
                <Link to="/" className="text-decoration-none">
                  <Button variant="outline-light" className="d-flex align-items-center px-3 shadow-sm">
                    <FaHome className="me-2" />
                    <span>Inicio</span>
                  </Button>
                </Link>
              </motion.div>
            </Col>
          </Row>

         
          <div className="text-center mb-5">
            <h1 className="fw-bold text-white mb-3">Términos y Condiciones</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '700px', fontSize: '1.1rem' }}>
              Al crear y utilizar un casillero con MBOX S. de R.L., el cliente acepta los siguientes términos y condiciones. Por favor, lea detenidamente estas políticas.
            </p>
          </div>

          
          <Row className="g-4">
            {termsSections.map((section, index) => (
              <Col lg={6} md={12} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.03, duration: 0.4 }}
                  className="h-100"
                >
                  <Card className="h-100 border-0 shadow bg-white rounded-3">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                        {section.icon}
                        <h5 className="fw-bold text-dark mb-0 ms-2">{section.title}</h5>
                      </div>
                      <div className="text-secondary lh-lg" style={{ fontSize: '0.95rem' }}>
                        {section.content}
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.4 }}
            className="mt-5"
          >
            <Card className="border-0 shadow-lg rounded-3 bg-white">
              <Card.Body className="p-4 p-md-5">
                <div className="mb-4 pb-2 border-bottom">
                  <h4 className="fw-bold text-dark mb-2">Contacto y Soporte</h4>
                  <p className="text-secondary mb-0">
                    Para consultas, reclamos o cualquier gestión relacionada con nuestros servicios, comuníquese a través de nuestros canales oficiales:
                  </p>
                </div>
                
                <Row className="g-4">
                  {contactInfo.map((contact, i) => (
                    <Col md={6} key={i}>
                      <div className="d-flex align-items-center text-dark p-3 rounded bg-light border">
                        <div>{contact.icon}</div>
                        <div>
                          {contact.link ? (
                            <a
                              href={contact.link}
                              className="text-dark text-decoration-none fw-medium"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {contact.text}
                            </a>
                          ) : (
                            <span className="text-dark fw-medium">{contact.text}</span>
                          )}
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            className="text-center mt-5 mb-4 pb-3"
          >
            <p className="text-white-50 fst-italic small mx-auto" style={{ maxWidth: '600px' }}>
              Al utilizar los servicios de MBOX S. de R.L., el cliente confirma haber leído, comprendido y aceptado los presentes Términos y Condiciones en su totalidad.
            </p>
          </motion.div>

        </motion.div>
      </Container>
    </section>
  );
};

export default TerminosYCondiciones;

